<template lang="pug">
.item
  .wrapper.d-flex.flex-md-column
    .left.d-flex.flex-column
      img(:src="content.area04_Content_PackageImage")
    .content.i_mt_4.i_mt_sm_0.i_ml_sm_4
      h5 {{ content.area04_Content_PackageTitle }}
      p.i_body_l.i_mt_2 {{ content.area04_Content_PackageBrief }}
  .content.range
    p.i_body_l.title 更多保障：
    p.i_body_l(v-html="content.area04_Content_PackageContent")

  .see_more_btn.btn_blue.contact_btn.sm.i_mt_sm_6(v-if="false",@click="toContactUs") 聯絡我們
</template>

<script>
export default {
  props: {
    content: Object,
  },
  methods: {
    toContactUs() {
      this.$router.push({ name: "CustomerServiceContactUs" });
      this.$emit("menuExpand", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/solution/item";

p.contact_btn {
  color: $color_blue_btn;
}
</style>
